import { tns } from "tiny-slider";

export const homepageSlider = () => {
    const homepageSliderContainer = document.getElementById('slider');
    if (homepageSliderContainer) {

        tns({
            container: homepageSliderContainer,
            items: 1,
            slideBy: 'page',
            controls: false,
            autoplay: true,
            autoplayTimeout: 10000,
            nav: true,
            lazyload: true,
            autoplayHoverPause: true,
            autoplayButtonOutput: false,
            onInit: function (slider) {
                // Once the slider is initialized, make the container visible
                setTimeout(() => {
                    slider.container.style.opacity = 1;
                }, 750);
            }
        });
    }


}
